import { render, staticRenderFns } from "./catalogGrid.vue?vue&type=template&id=1952ab4f&scoped=true&"
import script from "./catalogGrid.vue?vue&type=script&lang=js&"
export * from "./catalogGrid.vue?vue&type=script&lang=js&"
import style0 from "./catalogGrid.vue?vue&type=style&index=0&id=1952ab4f&prod&lang=css&"
import style1 from "./catalogGrid.vue?vue&type=style&index=1&id=1952ab4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952ab4f",
  null
  
)

export default component.exports